export default {
  routes: [
    {
      name: 'comments',
      path: '/admin/comments',
      component: () => import('./views/TheСommentsView.vue'),

    },

    {
      name: 'comment',
      path: '/admin/comments/:uuid',
      component: () => import('./views/TheСommentView.vue'),
    },
  ]
}
